<template>
  <div>
    <collapsibleItem>
      <div slot="heading">标记样式</div>
      <div slot="body" class="mt8">
        <div v-if="symbolType1 !== 'autoImage'">
          <span class="top_span mr8">绘制方式</span>
          <el-radio v-model="brushType" label="fill">填充</el-radio>
          <el-radio v-model="brushType" label="stroke">描边</el-radio>
        </div>
        <cx-select class="mt16" title="标记形状" :selectOptions="symbolTypeList" :value.sync="symbolType1" />
        <div class="data-item mt16" v-if="symbolType1 === 'autoImage'">
          <img-upload-simple :imgSrc.sync="symbolImage" />
        </div>
        <slider-and-input
            class="mt16 titleSingleLine"
            :value.sync="symbolSize"
            titlePosition="singleLine"
            title="标记大小"
            :sliderMax="100"
            suffix="px"
        />
        <div v-if="symbolType1 !== 'autoImage'">
          <chart-color-setting class="mt16" title="标记颜色" lineDirection="y" :color.sync="lineColor" />
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">涟漪样式</div>
      <div slot="body" class="mt8">
        <div v-if="symbolType1 !== 'autoImage'">
          <chart-color-setting class="" title="波纹颜色" :color.sync="roundColor" />
        </div>
        <slider-and-input
          class="mt16 titleSingleLine"
          :value.sync="scale"
          titlePosition="singleLine"
          title="波纹缩放比"
          :sliderMax="20"
          suffix="%"
        />
        <slider-and-input
            class="mt16 titleSingleLine"
            :value.sync="period"
            titlePosition="singleLine"
            title="动画时间"
            :sliderMax="20"
            suffix="秒"
        />
        <cx-check-box class="mt16" :value.sync="showEffectOnHover">高亮时显示波纹</cx-check-box>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">涟漪文字</div>
      <div slot="body" class="mt8">
        <cx-check-box :value.sync="showScatterText">显示涟漪文字</cx-check-box>
        <div v-show="showScatterText">
          <text-setting-update
            class="mt8"
            :fontColor.sync="labelFontColor"
            :fontFamily.sync="labelFontFamily"
            :fontSize.sync="labelFontSize"
            :fontWeight.sync="labelFontWeight"
          />
          <slider-and-input
            class="mt16 titleSingleLine"
            :value.sync="labelOffsetX"
            title="横轴偏移"
            titlePosition="singleLine"
            :sliderMin="-100"
            :sliderMax="100"
            suffix="px"
          />
          <slider-and-input
            class="mt16 titleSingleLine"
            :value.sync="labelOffsetY"
            title="纵轴偏移"
            titlePosition="singleLine"
            :sliderMin="-100"
            :sliderMax="100"
            suffix="px"
          />
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
export default {
  mixins: [],

  props: {
    options: {
      type: Object
    },
    seriesSettingItem: {
      type: Object
    },
    index: {
      type: Number
    },
    ids: {
      type: Object
    },
    seriesDataLen: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      collapseActiveNames: [""],
      symbolTypeList: [
        { label: "圆形", value: "circle" },
        { label: "矩形", value: "rect" },
        { label: "圆角矩形", value: "roundRect" },
        { label: "三角形", value: "triangle" },
        { label: "菱形", value: "diamond" },
        { label: "气球", value: "pin" },
        { label: "箭头", value: "arrow" },
        { label: "自定义图片", value: "autoImage" }
      ]
    }
  },
  created() {},
  watch: {},
  computed: {
    chartOption() {
      return this.options.chartOption
    },
    brushType: {
      get() {
        return this.seriesSettingItem.rippleEffectBrushType || "fill"
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".rippleEffectBrushType", false)
      }
    },
    period: {
      get() {
        return this.seriesSettingItem.rippleEffectPeriod
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".rippleEffectPeriod", false)
      }
    },
    symbolSize: {
      get() {
        return this.seriesSettingItem.symbolSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".symbolSize", false)
      }
    },
    scale: {
      get() {
        return this.seriesSettingItem.rippleEffectScale
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".rippleEffectScale", false)
      }
    },
    roundColor: {
      get() {
        return this.seriesSettingItem.rippleEffectColor || "rgba(27, 255, 254, 1)"
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".rippleEffectColor", false)
      }
    },
    lineColor: {
      get() {
        return this.seriesSettingItem.color || "rgba(27, 255, 254, 1)"
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".color", false)
      }
    },
    showScatterText: {
      get() {
        return this.seriesSettingItem.labelShow || false
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelShow", false)
      }
    },
    labelFontColor: {
      get() {
        return this.seriesSettingItem.labelFontColor || "rgba(255, 255, 255, 0.7)"
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelFontColor", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.seriesSettingItem.labelFontFamily || "sans-serif"
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelFontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.seriesSettingItem.labelFontSize || 8
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelFontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.seriesSettingItem.labelFontWeight || 400
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelFontWeight", false)
      }
    },
    labelOffsetX: {
      get() {
        return this.seriesSettingItem.labelOffset[0] || 0
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelOffset.0", false)
      }
    },
    labelOffsetY: {
      get() {
        return this.seriesSettingItem.labelOffset[1]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".labelOffset.1", false)
      }
    },
    symbolType1: {
      get() {
        return this.seriesSettingItem.symbolType || "circle"
      },
      set(newVal) {
        if (newVal !== "autoImage") {
          this.$changeOptionsEV(
            [newVal, newVal],
            [
              "chartOption.scatter.seriesData." + this.index + ".symbolType",
              "chartOption.scatter.seriesData." + this.index + ".symbol"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(
            [newVal, "image://" + this.symbolImage],
            [
              "chartOption.scatter.seriesData." + this.index + ".symbolType",
              "chartOption.scatter.seriesData." + this.index + ".symbol"
            ],
            false
          )
        }
      }
    },
    symbolImage: {
      get() {
        return this.seriesSettingItem.symbolImage || ""
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, "image://" + newVal],
          [
            "chartOption.scatter.seriesData." + this.index + ".symbolImage",
            "chartOption.scatter.seriesData." + this.index + ".symbol"
          ],
          false
        )
      }
    },
    showEffectOnHover: {
      get() {
        return this.seriesSettingItem.showEffectOnHover || false
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData." + this.index + ".showEffectOnHover", false)
        // 解决设置项不生效的问题
        if(!val){
          this.$changeOptionsEV(false, "chartOption.showScatter", false)
          this.$nextTick(()=>{
            this.$changeOptionsEV(true, "chartOption.showScatter", false)
          })
        }
      }
    },
  },
  methods: {}
}
</script>

<style scoped>
::v-deep .titleSingleLine .flex_box {
  flex-wrap: wrap;
}
::v-deep .titleSingleLine .flex_box .option_name {
  flex-basis: 100%;
}
</style>
